import React from "react";
import NonMultiCityForm from "./NonMultiCityForm";
import MultiCityForm from "./MultiCityForm";

const BizTripForm = ({
  data,
  activeTripType,
  flightTypes,
  payType,
  travelType,
  onFlightTypeSelect,
  onTravelTypeSelect,
  onPayTypeSelect,
  onTripTypeChange,
  onAddCity,
  onSelectActiveIndex,
  activeMCIndex,
  onAirportSelect,
  onTimeRangeSelect,
  onCheckAirlines,
  onDateSelection,
  onTravelReqChange,
  onCompanySelected,
  errors,
  selectedLeave,
  // carTypes,
  // hotelTypes,
  // companies,
  perDiemData,
  settingsData,
  companyList,
  costCenterList,
  projectList,
  onPrivilegeChange,
  privilegeCard,
  onDeleteCity,
}) => {
  // let startDate = parseInt(selectedLeave?.startDate);
  // let previousDate = new Date(startDate);
  // previousDate.setDate(previousDate.getDate() - 3);

  // let minStartDate;
  // let today = new Date();
  // today.setHours(0, 0, 0, 0);

  // if (previousDate < today) {
  //   minStartDate = today;
  // } else {
  //   minStartDate = previousDate;
  // }

  // let endDate = parseInt(selectedLeave?.endDate);
  // let minStartDate = new Date(selectedLeave?.startDate);
  // let maxEndDate = new Date(selectedLeave?.endDate);
  // maxEndDate.setDate(maxEndDate.getDate() + 3);
  // minStartDate.setDate(minStartDate.getDate() - 3);

  return (
    <>
      {activeTripType === "Multi City" ? (
        <MultiCityForm
          data={data}
          flightTypes={flightTypes}
          payType={payType}
          travelType={travelType}
          onFlightTypeSelect={onFlightTypeSelect}
          onTravelTypeSelect={onTravelTypeSelect}
          onPayTypeSelect={onPayTypeSelect}
          onTripTypeChange={onTripTypeChange}
          onAddCity={onAddCity}
          onSelectActiveIndex={onSelectActiveIndex}
          activeMCIndex={activeMCIndex}
          onAirportSelect={onAirportSelect}
          onTimeRangeSelect={onTimeRangeSelect}
          onCheckAirlines={onCheckAirlines}
          onDateSelection={onDateSelection}
          onTravelReqChange={onTravelReqChange}
          errors={errors}
          selectedLeave={selectedLeave}
          // minStartDate={minStartDate}
          // maxEndDate={maxEndDate}
          // carTypes={carTypes}
          // hotelTypes={hotelTypes}
          // companies={companies}
          onCompanySelected={onCompanySelected}
          perDiemData={perDiemData}
          settingsData={settingsData}
          companyList={companyList}
          costCenterList={costCenterList}
          projectList={projectList}
          onPrivilegeChange={onPrivilegeChange}
          privilegeCard={privilegeCard}
          onDeleteCity={onDeleteCity}
          activeTripType={activeTripType}
        />
      ) : (
        <NonMultiCityForm
          onFlightTypeSelect={onFlightTypeSelect}
          onTravelTypeSelect={onTravelTypeSelect}
          onPayTypeSelect={onPayTypeSelect}
          data={data && data[0]}
          flightTypes={flightTypes}
          payType={payType}
          travelType={travelType}
          selectedLeave={selectedLeave}
          onAirportSelect={onAirportSelect}
          onTimeRangeSelect={onTimeRangeSelect}
          onCheckAirlines={onCheckAirlines}
          onDateSelection={onDateSelection}
          onTravelReqChange={onTravelReqChange}
          errors={errors[0]}
          // minStartDate={minStartDate}
          // maxEndDate={maxEndDate}
          // carTypes={carTypes}
          // hotelTypes={hotelTypes}
          // companies={companies}
          onCompanySelected={onCompanySelected}
          perDiemData={perDiemData}
          settingsData={settingsData}
          companyList={companyList}
          costCenterList={costCenterList}
          projectList={projectList}
          onPrivilegeChange={onPrivilegeChange}
          privilegeCard={privilegeCard}
          activeTripType={activeTripType}
        />
      )}
    </>
  );
};

export default BizTripForm;
